import { render, staticRenderFns } from "./CourseSlideshare.vue?vue&type=template&id=d8bfca70&scoped=true&"
import script from "./CourseSlideshare.vue?vue&type=script&lang=js&"
export * from "./CourseSlideshare.vue?vue&type=script&lang=js&"
import style0 from "./CourseSlideshare.vue?vue&type=style&index=0&id=d8bfca70&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bfca70",
  null
  
)

component.options.__file = "CourseSlideshare.vue"
export default component.exports